import React from "react";
import { 
  FiMenu,
  FiX,
  FiMoon,
  FiSun,
  FiClock,
  FiLogOut,
  FiHome, 
  FiMessageSquare,
  FiDatabase,
  FiShield,
  FiColumns,
  FiFileText,
  FiHeart,
  FiUsers
} from "react-icons/fi";

function Sidebar({ currentPage, onNavigate, isOpen, onToggleSidebar, theme, onToggleTheme, onLogout, isAdmin }) {
  const homeItem = { id: "home", icon: FiHome, label: "Home" };
  const appItems = [
    { id: "vault-crm", icon: FiDatabase, label: "Vault CRM Migration" },
    { id: "veeva-gpt", icon: FiMessageSquare, label: "Veeva GPT" },
    { id: "doc-redact", icon: FiShield, label: "DocRedact", comingSoon: true },
    { id: "docs-compare", icon: FiColumns, label: "Docs Compare", comingSoon: true },
    { id: "doc-template-converter", icon: FiFileText, label: "Doc Template Converter", comingSoon: true },
    { id: "universal-patient-language", icon: FiHeart, label: "Universal Patient Language", comingSoon: true },
  ];
  const aiAssistantItems = [];
  const MenuIcon = isOpen ? FiX : FiMenu;
  const ThemeIcon = theme === "light" ? FiMoon : FiSun;

  const renderMenuItem = (item) => {
    const IconComponent = item.icon;
    const isActive = currentPage === item.id || 
      (currentPage === "home" && item.id === "home") ||
      (currentPage === "migration-wizard" && item.id === "vault-crm");

    return (
      <li key={item.id}>
        <button
          className={`sidebar-menu-item ${isActive ? "active" : ""}`}
          onClick={() => onNavigate(item.id)}
          title={item.label}
          aria-label={item.label}
        >
          <IconComponent className="sidebar-menu-icon" />
          <span className="sidebar-item-label">{item.label}</span>
          {item.comingSoon && (
            <span className="sidebar-coming-soon-indicator" aria-hidden="true">
              <FiClock className="sidebar-coming-soon-icon" />
              <span className="sidebar-coming-soon-text">Soon</span>
            </span>
          )}
        </button>
      </li>
    );
  };

  return (
    <aside className={`sidebar ${isOpen ? "open" : ""}`}>
      <nav className="sidebar-nav">
        <div className="sidebar-top-control">
          <button
            type="button"
            className="sidebar-control-btn"
            onClick={onToggleSidebar}
            aria-label={isOpen ? "Close menu" : "Open menu"}
            aria-expanded={isOpen}
          >
            <MenuIcon className="sidebar-control-icon" />
            <span className="sidebar-control-label">Menu</span>
          </button>
        </div>

        <div className="sidebar-section">
          <span className="sidebar-section-title">Home &amp; Theme</span>
          <ul className="sidebar-menu section-menu">
            {renderMenuItem(homeItem)}
          </ul>
          <div className="sidebar-controls">
            <button
              type="button"
              className="sidebar-control-btn"
              onClick={onToggleTheme}
              aria-label={theme === "light" ? "Enable dark mode" : "Enable light mode"}
            >
              <ThemeIcon className="sidebar-control-icon" />
              <span className="sidebar-control-label">Theme</span>
            </button>
          </div>
        </div>

        <div className="sidebar-section">
          <span className="sidebar-section-title">Available Apps</span>
          <ul className="sidebar-menu section-menu">
            {appItems.map((item) => renderMenuItem(item))}
          </ul>
        </div>

        <div className="sidebar-section">
          <span className="sidebar-section-title">AI Assistants</span>
          <ul className="sidebar-menu section-menu">
            {aiAssistantItems.map((item) => renderMenuItem(item))}
          </ul>
        </div>

        {isAdmin && (
          <div className="sidebar-section">
            <span className="sidebar-section-title">Admin</span>
            <ul className="sidebar-menu section-menu">
              {renderMenuItem({ id: "admin-users", icon: FiUsers, label: "User Management" })}
            </ul>
          </div>
        )}

        <div className="sidebar-bottom-actions">
          <button
            type="button"
            className="sidebar-control-btn sidebar-logout-btn"
            onClick={onLogout}
            aria-label="Logout"
          >
            <FiLogOut className="sidebar-control-icon" />
            <span className="sidebar-control-label">Logout</span>
          </button>
        </div>
      </nav>
    </aside>
  );
}

export default Sidebar;